import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  saveAsLayer: {
    id: 'saveAsLayer',
    defaultMessage: 'Save as a layer',
  },
  layerProgress: {
    id: 'layerProgress',
    defaultMessage:
      'We will save your progress as a layer. You will be able to continue your work in the Layers section from the left menu.',
  },
  enterLayerName: {
    id: 'enterLayerName',
    defaultMessage: 'Layer name',
  },
  saveAndContinue: {
    id: 'saveAndContinue',
    defaultMessage: 'Save and continue',
  },
});

export default { ...globalIntl, ...m };
